import { createClient } from '@sanity/client';
import { config } from '@/config/environment';

export const sanityClient = createClient({
  projectId: config.sanity.projectId,
  dataset: config.sanity.dataset,
  useCdn: false,
  apiVersion: '2023-11-29',
});
